import Select2Controller from '../select2_controller';

export default class extends Select2Controller {
  defaultOptions() {
    return {
      ...super.defaultOptions(),
      placeholder: 'Assign characters…',
      allowClear: true,
      closeOnSelect: false,
    };
  }
}

